import { FunctionComponent } from "react";

import { ListPerson } from "@/pages/Private/pages/List/schema/list";

export const OrgCategory: FunctionComponent<{
	row: ListPerson;
}> = ({ row }) => {
	return (
		<div className="text-sm text-ellipsis text-status-info overflow-hidden w-full max-w-full whitespace-nowrap text-left">
			{row.prospect?.organization?.scoreCompanyCategoryResult?.result}
		</div>
	);
};
